import { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import styles from '../style/wallet_card.module.scss';
import { CDN_URL } from '../ConfigPublic';
import moment from 'moment';
import 'moment/locale/es';
interface WalletCardProps {
    saveUrl?: string;
    accountCode?: string;
    tier: string;
    tierLevel: number;
    points: number;
    userName: string;
    onDownloadGooglePass?: () => void;
    onDownloadApplePass?: () => void;
    loadingGoogle?: boolean;
    loadingApple?: boolean;
    level_id?: number;
    expiryDate?: number;
}

export var WalletCard = ({ saveUrl, accountCode, tier, tierLevel, points, userName, onDownloadGooglePass, onDownloadApplePass, loadingGoogle, loadingApple, level_id, expiryDate }: WalletCardProps)=>{
    var [imgTimestamp] = useState(() => moment().valueOf());
    var [logoError, setLogoError] = useState<boolean>(false);
    var [heroError, setHeroError] = useState<boolean>(false);
    var hasImageError = logoError || heroError;

    var bgColors = {
        1: '#ffff',
        2: '#4c2317', 
        3: '#c28c2b', 
    };
    var bgColor = bgColors[tierLevel as keyof typeof bgColors] || '#3E2410';
    var textColor = tierLevel === 1 ? '#000000' : '#ffffff';
    
    var userIdMatch = accountCode?.match(/^(?:CCN|COCOAN)-(\d+)$/);
    var userId = userIdMatch ? userIdMatch[1] : '';
    var qrValue = userId ? `${typeof window !== 'undefined' ? window.location.origin : 'https://cocoan.mx'}/rewards?referal=${userId}` : (accountCode || saveUrl || 'COCOAN');
    
    var isIOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
    var isAndroid = typeof navigator !== 'undefined' && /android/i.test(navigator.userAgent);

    return <div className={styles.walletContainer}>
        <div className={styles.cardMockup} style={{ background: bgColor, color: textColor }}>
            <div className={styles.cardTopHalf}>
                <div className={styles.topRow}>
                    <div className={styles.nameBlock}>
                        <div className={styles.userName}>
                            {userName.split(' ')[0]}<br />
                            {userName.split(' ').slice(1).join(' ')}
                        </div>
                        {tier ? (
                            <div className={styles.tierName}>
                                <img 
                                    src={`${CDN_URL}/wallet/${level_id}_name.png?t=${imgTimestamp}`} 
                                    alt={tier} 
                                    style={{ maxWidth: '100%', maxHeight: 20, objectFit: 'contain', margin: '5px 0' }}
                                    onError={(e) => {
                                        var target = e.target as HTMLImageElement;
                                        target.style.display = 'none';
                                        if (target.nextElementSibling) {
                                            (target.nextElementSibling as HTMLElement).style.display = 'inline';
                                        }
                                    }}
                                />
                                <span style={{ display: 'none' }}>{tier}</span>
                            </div>
                        ) : null}
                    </div>
                    <div className={styles.logoBlock}>
                        <img src={`${CDN_URL}/wallet/${level_id}_logo_google.png?t=${imgTimestamp}`} alt="Logo" className={styles.topLogoImg} onError={(e) => { 
                            (e.target as HTMLImageElement).style.display = 'none'; 
                            setLogoError(true);
                        }} />
                    </div>
                </div>
                
                <div className={styles.middleRow}>
                    <div className={styles.pointsBlock}>
                        <div className={styles.starIcon}>★</div>
                        <div className={styles.pointsValue}>{points}</div>
                        <div className={styles.pointsLabel}>Puntos</div>
                    </div>
                    {expiryDate ? (
                        <div className={styles.pointsBlock}>
                            <div className={styles.pointsValue} style={{ fontSize: 12 }}>{moment.unix(expiryDate).locale('es').format('DD/MMM/YYYY')}</div>
                            <div className={styles.pointsLabel}>Vencimiento</div>
                        </div>
                    ) : null}
                </div>
            </div>

            <div className={styles.cardBottomHalf}>
                <img src={`${CDN_URL}/wallet/${level_id}_hero_google.png?t=${imgTimestamp}`} alt="Hero" className={styles.heroImg} onError={(e) => { 
                    (e.target as HTMLImageElement).style.display = 'none'; 
                    setHeroError(true);
                }} />
            </div>

            <div className={styles.qrOverlap}>
                <QRCodeSVG value={qrValue} size={120} className={styles.qrCode} />
            </div>
        </div>

        <div className={styles.osButtons}>
            {hasImageError ? (
                <div style={{ color: '#e74c3c', fontSize: 13, textAlign: 'center', marginTop: 10, width: '100%', padding: '0 20px' }}>
                    Tu tarjeta digital no está disponible por el momento.
                </div>
            ) : (
                <>
                    {(!isIOS || isAndroid) && (
                        <img 
                            src="/badges/add_to_google_wallet.svg" 
                            alt="Agregar a Google Wallet"
                            className={styles.osButtonImg}
                            onClick={onDownloadGooglePass || (() => { if (saveUrl) window.location.href = saveUrl; })}
                            style={{ opacity: loadingGoogle ? 0.6 : 1, cursor: loadingGoogle ? 'wait' : 'pointer' }}
                        />
                    )}
                    {(!isAndroid || isIOS) && (
                        <img 
                            src="/badges/add_to_apple_wallet.svg" 
                            alt="Agregar a Apple Wallet"
                            className={styles.osButtonImg}
                            onClick={onDownloadApplePass}
                            style={{ opacity: loadingApple ? 0.6 : 1, cursor: loadingApple ? 'wait' : 'pointer' }}
                        />
                    )}
                </>
            )}
        </div>
    </div>;
};
